const metersToPixelsAtMaxZoom = (meters, latitude) => meters / 0.075 / Math.cos(latitude * Math.PI / 180);
const POINT_COUNT_100 = 100;
const POINT_COUNT_650 = 650;


function createPolygonLayers(layers) {
    const mapItemsCount = layers.reduce((prev, cur) => {
        const key = [`${cur.lat}, ${cur.lng}`];
        prev[key] = (prev[key] || 0) + 1;
        return prev;
    }, {});

    return layers.map(item => {
        const key = [`${item.lat}, ${item.lng}`];
        if(mapItemsCount[key] > 1) {
            item.countOfSamePositions = mapItemsCount[key]
        }
        return createPolygonLayer(item)
    })
}


function createPolygonLayer(item) {
    return {
        type: "Feature",
        id: item.id,
        properties: {
            ...item,
            center: [item.lat, item.lng],
            radius: item.protection_area_radius_km * 1000,
            // radius: metersToPixelsAtMaxZoom(item.protection_area_radius_km * 1000, item.lat),
            lat: item.lat
        },
        geometry: {
            type: "Point",
            // coordinates: createGeoJSONCircle([item.lat, item.lng], item.protection_area_radius_km)
            coordinates: [item.lat, item.lng]
        }
    }
}
function createCircleLayer(item) {
    let lat = item ? item.center_latitude : 0;
    let lng = item ? item.center_longitude : 0;
    let protection_area_radius_km = item ? item.radius : 0;
    let layer = [{
        type: "Feature",
        id: 1,
        properties: {
            ...item,
            center: [lng, lat],
            radius: protection_area_radius_km * 1000,
            lat: lng
        },
        geometry: {
            type: "Point",
            coordinates: [lng, lat]
        }
    }];
    return layer;

}

function findCircleById(items, index) {
    return items.findIndex(item => item.properties.id === index )
}

function createMapCirclePolygons(id, source) {
    return {
        id,
        type: 'circle',
        source,
        filter: ["all", ['!has', 'point_count'], ["==", "protection_area_radius_enabled", 1]],
        paint: {
            "circle-radius": [
                "interpolate",
                ["exponential", 2],
                ["zoom"],
                0, 0,
                22,
                ["/", ["/", ["get", "radius"], 0.01866137981], ["cos", ["*", ['get', 'lat'], ["/", ["pi"], 180]]]]
            ],
            'circle-color': '#2C64FF',
            'circle-stroke-color': '#2C64FF',
            'circle-stroke-width': 2,
            "circle-opacity": 0.05
        }
    };
}
function createMapClusterMarkersSource(source) {
    return {
        type: 'geojson',
        data: source,
        cluster: true,
        clusterMaxZoom: 12,
        clusterRadius: 100,
    };
}
function createMapClustersLayer(id, source, colorMain) {
    return {
        id,
        type: 'circle',
        source,
        filter: ['has', 'point_count'],
        paint: {
            'circle-color': ['step', ['get', 'point_count'], colorMain, POINT_COUNT_100, colorMain, POINT_COUNT_650, '#fff'],
            'circle-radius': ['step', ['get', 'point_count'], 13, POINT_COUNT_100, 20, POINT_COUNT_650, 26],
            'circle-stroke-color': ['step', ['get', 'point_count'], colorMain, POINT_COUNT_100, colorMain, POINT_COUNT_650, colorMain],
            'circle-stroke-opacity': ['step', ['get', 'point_count'], 0.2, POINT_COUNT_100, 0.3, POINT_COUNT_650, 0.4],
            'circle-stroke-width': ['step', ['get', 'point_count'], 3, POINT_COUNT_100, 5, POINT_COUNT_650, 7],
        },
    };
}

function createMapUnClustersLayer(id, source) {
    return {
        id,
        type: 'circle',
        source,
        filter: ["all", ['!has', 'point_count'], ['!has', 'countOfSamePositions']],
        paint: {
            'circle-radius': 25,
            'circle-color': 'rgba(255, 255, 255, 0)'
        }
    };
}
function createMapUnclusteredIconsOnSamePosition(id, source) {
    return {
        id:  id,
        type: 'symbol',
        source: source,
        filter: ["all", ['!has', 'point_count'], [">", "countOfSamePositions", 1]],
        paint: {
            'text-translate': [0, -7],
        },
        layout: {
            'icon-image': 'MARKER_SAME_POSITION',
            'icon-size': 0.65,
            'icon-allow-overlap': true,
            'text-field': ['get', 'countOfSamePositions'],
            'text-font': ['Arial Unicode MS Regular'],
            'text-size': 16,
            'text-allow-overlap': true,
        },
    }
}
function createMapClusterCountsLayer(id, source) {
    return {
        id,
        type: 'symbol',
        source,
        filter: ['has', 'point_count'],
        layout: {
            'text-field': '{point_count_abbreviated}',
            "text-size": ['step', ['get', 'point_count'], 11, POINT_COUNT_100, 14, POINT_COUNT_650, 16],
            "text-font": ["Arial Unicode MS Bold"],

        },
        paint: {
            "text-color": ['step', ['get', 'point_count'], '#fff', POINT_COUNT_100, '#fff', POINT_COUNT_650, '#000'],
        }
    };
}

function createMapUnclusteredAddressImage(id, source) {
    return {
        id:  id,
        type: 'symbol',
        source: source,
        filter: ['!', ['has', 'point_count']],
        layout: {
            'icon-image': ["get", "status"],
            'icon-size': 0.5,
            'icon-allow-overlap': true,
        },
    }

}

function addImages(map, images) {
    const addImage = (map, id, url) => {
        return new Promise((resolve, reject) => {
            map.loadImage(url, (error, image) => {
                if(error) {
                    reject(error);
                    return;
                }
                map.addImage(id, image);
                resolve(image);
            });
        });
    }
    const promises = images.map( imageData => addImage(map, imageData.id, imageData.url) );
    return Promise.all(promises);
}

export {
    metersToPixelsAtMaxZoom,
    createPolygonLayers,
    createPolygonLayer,
    createCircleLayer,
    findCircleById,
    createMapCirclePolygons,
    createMapClusterMarkersSource,
    createMapClusterCountsLayer,
    createMapClustersLayer,
    createMapUnClustersLayer,
    createMapUnclusteredIconsOnSamePosition,
    createMapUnclusteredAddressImage,
    addImages
}